import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { MatSnackBar } from '@angular/material';
import { isEmptyOrNull } from './utils';

@Injectable({
  providedIn: 'root'
})
export class AccountAddonService {
  protected defaultController = `https://api.${environment.baseUrl}/api/`;
  protected slug = 'accountaddon';
  constructor(public http: HttpClient, private snackBar: MatSnackBar) {
  }

  public getAccountAddon(id: string): Observable<any> {
    return this.http.get(`${this.defaultController}${this.slug}/${id}`);
  }

  public getAllAccountAddons(): Observable<any> {
    return this.http.get(`${this.defaultController}${this.slug}`);
  }

  public deleteAccountAddon(id: string): Observable<any> {
    return this.http.delete(`${this.defaultController}${this.slug}/${id}`).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err53', {
          duration: 5000,
        });
      }));
  }

  public addAccountAddon(payload: any): Observable<any> {
    return this.http.post(`${this.defaultController}${this.slug}`, payload).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err52', {
          duration: 5000,
        });
      }));
  }

  public editAccountAddon(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.defaultController}${this.slug}/${id}`, payload).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err51', {
          duration: 5000,
        });
      }));
  }
}
